/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

import { toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class OriginalItem extends PureComponent {
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = "";
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = "," + (parseInt(str) % 1000) + "00" + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = "," + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ",0" + (parseInt(str) % 1000) + Money;
          else Money = ",00" + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _online = () => {
    const { goodSerial, SaleActive } = this.props.childProps;
    if (SaleActive) {
      window.open("https://shop.aniplustv.com/Item/" + goodSerial, "", "");
    } else {
      toast.warn("오프라인에서만 구매가 가능한 굿즈입니다.");
    }
  };

  render() {
    const { goodTitle, dcPrice, good_Img, type } = this.props.childProps;
    return (
      <Fragment>
        <div
          className={
            type === "collabo" ? "store_card cafe" : "store_card orgin"
          }
        >
          {/* 카드 상단/ */}
          <div className="store_card_top">
            <span className="tag">
              {type === "collabo" ? "콜라보 굿즈" : "오리지널 굿즈"}
            </span>
          </div>
          {/* 카드 타이틀/ */}
          <div className="store_card_tit">
            <a
              onClick={this._online}
              style={{ cursor: "pointer" }}
              className="prd_name"
            >
              {goodTitle}
            </a>
            <p className="price">{this._CommaFormatted(dcPrice)}원</p>
          </div>
          {/* 카드 썸네일/ */}
          <div className="store_card_thumb" onClick={this._online}>
            <img src={good_Img} />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(OriginalItem)));
